/**
 * Trust Badges Slider
 * Auto-scrolling infinite carousel using requestAnimationFrame
 */
class TrustBadgesSlider {
  constructor() {
    this.track = document.querySelector('[data-badges-track]');
    if (!this.track) return;

    this.position = 0;
    this.speed = 0.5; // pixels per frame
    this.animationId = null;
    this.init();
  }

  init() {
    this.animate();
  }

  animate() {
    this.position -= this.speed;

    // Reset when half the track has scrolled (seamless loop)
    if (Math.abs(this.position) >= this.track.scrollWidth / 2) {
      this.position = 0;
    }

    this.track.style.transform = `translateX(${this.position}px)`;
    this.animationId = requestAnimationFrame(() => this.animate());
  }

  destroy() {
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
    }
  }
}

// Initialize on page load
let trustBadgesSliderInstance = null;

document.addEventListener('DOMContentLoaded', () => {
  trustBadgesSliderInstance = new TrustBadgesSlider();
});

// Re-initialize for Shopify theme editor
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('[data-badges-track]')) {
    if (trustBadgesSliderInstance) {
      trustBadgesSliderInstance.destroy();
    }
    trustBadgesSliderInstance = new TrustBadgesSlider();
  }
});

// Cleanup on section unload
document.addEventListener('shopify:section:unload', (event) => {
  if (event.target.querySelector('[data-badges-track]')) {
    if (trustBadgesSliderInstance) {
      trustBadgesSliderInstance.destroy();
      trustBadgesSliderInstance = null;
    }
  }
});
